import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "../../lib/utils";

const badgeVariants = cva(
	"inline-flex items-center rounded-full border border-slate-200 px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 dark:border-slate-800 dark:focus:ring-slate-300",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-slate-900 text-slate-50 hover:bg-slate-900/80 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50/80",
				secondary:
					"border-transparent bg-slate-200 text-slate-500 hover:bg-slate-100/80 dark:bg-slate-800 dark:text-slate-50 dark:hover:bg-slate-800/80",
				destructive:
					"border-transparent bg-[#F5D5D8] text-[#AF1623]",
				outline: "border-gray-400 text-gray-400",
				success:
					"border-transparent bg-[#D1E8DF] text-[#048153] hover:bg-green-200/80",
				warning:
					"border-transparent bg-[#FFEEDB] text-[#ED8F1C] hover:bg-orange-200/80",
				on_hold:
					"border-transparent bg-[#DBEAFE] text-[#155DFC] hover:bg-[#DBEAFE]",
				expired:
					"border-transparent bg-[#E5E7EB] text-[#4B5563] hover:bg-[#E5E7EB]",
				dropped_off:
					"border-transparent bg-[#E9D4FF] text-[#9810FA] hover:bg-[#E9D4FF]",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	);
}

export { Badge, badgeVariants };
